import React, { Fragment } from "react";
import { array } from "prop-types";
import stylesDocs from "./stylesDocs.scss";

const getSingleLast = (arr) => {
  const result = {};

  arr.reverse().forEach((item) => {
    if (!result[item.TypeCode]) {
      result[item.TypeCode] = item;
    }
  });

  return Object.values(result);
};

const DocumentationFileList = ({ documentationFiles }) => {
  const documents = getSingleLast(documentationFiles);
  return (
    <div className="mt-1">
      <span>
        {documents.length} Document
        {documents.length > 1 && "s"} already submitted:
      </span>
      <ul className={`list-unstyled ${stylesDocs.documentationFiles__list}`}>
        {documents.map((f) => (
          <Fragment key={f.FileRef}>
            <li style={{ marginBottom: "8px" }}>
              <img
                style={{ width: "12px" }}
                src="/images/icons/timesheet-approve.svg"
              />
              <span style={{ fontSize: "0.75rem", marginLeft: "6px" }}>
                {f.DisplayName}
              </span>
            </li>
          </Fragment>
        ))}
      </ul>
    </div>
  );
};

DocumentationFileList.propTypes = {
  documentationFiles: array,
};

export default DocumentationFileList;
